import React, { useState, useEffect } from 'react';
import { Container, Card, Table, Button, Row, Col, Form, Badge, Alert, InputGroup } from 'react-bootstrap';
import {
  FaPlus, FaEdit, FaTrash, FaSearch, FaFilter, FaTimes,
  FaIdBadge, FaBuilding, FaIdCard, FaCalendarAlt,
  FaExclamationTriangle, FaUsers, FaUserTie,
  FaShoppingCart, FaCheckCircle, FaArrowRight, FaUser, FaBox
} from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import supabase from '../../supabaseClient';
import { useAuth } from '../../hooks/useAuth';

// Função para formatar CPF com máscara
const formatCpf = (cpf) => {
  // Remove tudo que não for número
  const numericCpf = cpf.replace(/\D/g, '');
  
  // Aplica a máscara XXX.XXX.XXX-XX
  if (numericCpf.length <= 3) {
    return numericCpf;
  } else if (numericCpf.length <= 6) {
    return `${numericCpf.slice(0, 3)}.${numericCpf.slice(3)}`;
  } else if (numericCpf.length <= 9) {
    return `${numericCpf.slice(0, 3)}.${numericCpf.slice(3, 6)}.${numericCpf.slice(6)}`;
  } else {
    return `${numericCpf.slice(0, 3)}.${numericCpf.slice(3, 6)}.${numericCpf.slice(6, 9)}-${numericCpf.slice(9, 11)}`;
  }
};

// Função para remover máscara do CPF
const removeCpfMask = (cpf) => {
  return cpf.replace(/\D/g, '');
};

// Função para validar CPF
// Função para validar CPF - VERSÃO CORRIGIDA
const validateCpf = (cpf) => {
  // Remove formatação
  const cleanCpf = cpf.replace(/\D/g, '');
  
  // Verifica se tem 11 dígitos
  if (cleanCpf.length !== 11) {
    return false;
  }
  
  // Verifica se todos os dígitos são iguais
  if (/^(\d)\1{10}$/.test(cleanCpf)) {
    return false;
  }
  
  // Valida primeiro dígito verificador
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += parseInt(cleanCpf.charAt(i)) * (10 - i);
  }
  
  // CORREÇÃO: Primeiro calcular o resto, depois aplicar a regra
  let remainder = sum % 11;
  let digit1 = remainder < 2 ? 0 : 11 - remainder;
  
  if (parseInt(cleanCpf.charAt(9)) !== digit1) {
    return false;
  }
  
  // Valida segundo dígito verificador
  sum = 0;
  for (let i = 0; i < 10; i++) {
    sum += parseInt(cleanCpf.charAt(i)) * (11 - i);
  }
  
  // CORREÇÃO: Primeiro calcular o resto, depois aplicar a regra
  remainder = sum % 11;
  let digit2 = remainder < 2 ? 0 : 11 - remainder;
  
  return parseInt(cleanCpf.charAt(10)) === digit2;
};

// Exemplo de uso:
console.log(validateCpf('366.392.558-71')); // true (agora funciona corretamente!)
console.log(validateCpf('111.111.111-11')); // false (todos iguais)
console.log(validateCpf('123.456.789-09')); // true

const CadastroCredenciais = () => {
  const navigate = useNavigate();
  const { user, hasPermission } = useAuth();
  
  // Estados
  const [showForm, setShowForm] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [editingCredencial, setEditingCredencial] = useState(null);
  const [showFilters, setShowFilters] = useState(false);
  const [filtroEmpresa, setFiltroEmpresa] = useState('');
  const [activeModalTab, setActiveModalTab] = useState('dados');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  // Estados para validação de CPF
  const [cpfError, setCpfError] = useState('');
  const [cpfValid, setCpfValid] = useState(null);
  
  // Estados para dados do banco
  const [credenciais, setCredenciais] = useState([]);
  const [expositores, setExpositores] = useState([]);
  const [produtos, setProdutos] = useState([]);
  const [eventos, setEventos] = useState([]);
  
  // NOVO: Estado para o expositor logado
  const [expositorLogado, setExpositorLogado] = useState(null);
  const [eventosVinculados, setEventosVinculados] = useState([]);
  
  // Estado para formulário
  const [formData, setFormData] = useState({
    nome: '',
    cpf: '',
    empresa: '',
    tipo_credencial: '',
    observacoes: '',
    evento_id: ''
  });
  
  // Filtros
  const [filters, setFilters] = useState({
    search: '',
    empresa: '',
    tipo_credencial: ''
  });

  // Estados para controle do carrinho
  const [cartItemsCount, setCartItemsCount] = useState(0);
  const [showCartNotification, setShowCartNotification] = useState(false);
  const [lastAddedItem, setLastAddedItem] = useState(null);

  // Tipos de credencial
  const tiposCredencial = [
    { id: 'representante', nome: 'Representante da Empresa' },
    { id: 'funcionario', nome: 'Funcionário' },
    { id: 'visitante', nome: 'Visitante Autorizado' },
    { id: 'fornecedor', nome: 'Fornecedor/Parceiro' },
    { id: 'convidado', nome: 'Convidado Especial' }
  ];

  // Manipular mudança no campo CPF
  const handleCpfChange = (e) => {
    const { value } = e.target;
    
    // Remove tudo que não for número
    const cpfLimpo = value.replace(/\D/g, '');
    
    // Limita a 11 dígitos
    if (cpfLimpo.length <= 11) {
      // Formata o CPF com máscara
      const cpfFormatado = formatCpf(cpfLimpo);
      
      setFormData({
        ...formData,
        cpf: cpfFormatado
      });

      // Validar CPF se estiver completo
      if (cpfLimpo.length === 11) {
        const isValid = validateCpf(cpfFormatado);
        setCpfValid(isValid);
        
        if (!isValid) {
          setCpfError('CPF inválido. Verifique os números digitados.');
        } else {
          setCpfError('');
        }
      } else {
        setCpfValid(null);
        setCpfError('');
      }
    }
  };

  // NOVA FUNÇÃO: Verificar se usuário é administrador
  const isAdmin = () => {
    return hasPermission && (hasPermission('admin') || hasPermission('administrador') || user?.role === 'admin');
  };

  // NOVA FUNÇÃO: Buscar expositor logado baseado no email do usuário
  const fetchExpositorLogado = async () => {
    try {
      if (!user?.email) {
        console.log('Usuário não logado ou sem email');
        return;
      }

      if (isAdmin()) {
        console.log('Usuário é administrador - não vinculado a expositor específico');
        setExpositorLogado(null);
        await fetchTodosEventos();
        return;
      }

      console.log('Buscando expositor para o email:', user.email);
      
      const { data, error } = await supabase
        .from('caex_expositores')
        .select('*')
        .eq('email', user.email)
        .eq('ativo', true)
        .single();
      
      if (error) {
        if (error.code === 'PGRST116') {
          console.log('Nenhum expositor encontrado para este email');
          setError('Nenhum expositor encontrado para este usuário. Entre em contato com o administrador.');
          return;
        }
        throw error;
      }
      
      console.log('Expositor encontrado:', data);
      setExpositorLogado(data);
      
      await fetchEventosVinculados(data.id);
      
    } catch (error) {
      console.error('Erro ao buscar expositor logado:', error);
      setError('Erro ao carregar dados do expositor. Tente novamente.');
    }
  };

  // NOVA FUNÇÃO: Buscar todos os eventos (para administradores)
  const fetchTodosEventos = async () => {
    try {
      console.log('Buscando todos os eventos (admin)...');
      
      const { data, error } = await supabase
        .from('caex_eventos')
        .select('*')
        .eq('ativo', true)
        .order('data_inicio', { ascending: false });
      
      if (error) throw error;
      
      console.log('Todos os eventos carregados:', data);
      setEventosVinculados(data || []);
      
    } catch (error) {
      console.error('Erro ao buscar todos os eventos:', error);
      setEventosVinculados([]);
    }
  };

  // NOVA FUNÇÃO: Buscar eventos vinculados ao expositor selecionado (para admin)
  const fetchEventosVinculadosAoExpositor = async (expositorId) => {
    try {
      console.log('Buscando eventos vinculados ao expositor selecionado:', expositorId);
      
      const { data, error } = await supabase
        .from('caex_expositor_evento')
        .select(`
          evento_id,
          caex_eventos (
            id,
            nome,
            descricao,
            data_inicio,
            data_fim,
            local,
            status
          )
        `)
        .eq('expositor_id', expositorId);
      
      if (error) throw error;
      
      const eventosData = data?.map(item => item.caex_eventos).filter(evento => evento) || [];
      
      console.log('Eventos vinculados ao expositor encontrados:', eventosData);
      setEventosVinculados(eventosData);
      
    } catch (error) {
      console.error('Erro ao buscar eventos vinculados ao expositor:', error);
      setEventosVinculados([]);
    }
  };

  // NOVA FUNÇÃO: Buscar eventos vinculados ao expositor
  const fetchEventosVinculados = async (expositorId) => {
    try {
      console.log('Buscando eventos vinculados ao expositor:', expositorId);
      
      const { data, error } = await supabase
        .from('caex_expositor_evento')
        .select(`
          evento_id,
          caex_eventos (
            id,
            nome,
            descricao,
            data_inicio,
            data_fim,
            local,
            status
          )
        `)
        .eq('expositor_id', expositorId);
      
      if (error) throw error;
      
      const eventosData = data?.map(item => item.caex_eventos).filter(evento => evento) || [];
      
      console.log('Eventos vinculados encontrados:', eventosData);
      setEventosVinculados(eventosData);
      
    } catch (error) {
      console.error('Erro ao buscar eventos vinculados:', error);
      setEventosVinculados([]);
    }
  };

  // NOVA FUNÇÃO: Carregar carrinho do banco de dados
  const loadCartFromDatabase = async () => {
    if (!user?.id) {
      setCartItemsCount(0);
      return;
    }

    try {
      const { data, error } = await supabase
        .from('caex_carrinho_pedido')
        .select('quantidade')
        .eq('usuario_id', user.id);

      if (error) throw error;

      const totalItems = data.reduce((total, item) => total + item.quantidade, 0);
      setCartItemsCount(totalItems);
    } catch (error) {
      console.error('Erro ao carregar carrinho:', error);
      setCartItemsCount(0);
    }
  };

  // NOVA FUNÇÃO: Adicionar credencial ao carrinho no banco de dados
 // NOVA FUNÇÃO CORRIGIDA: Adicionar credencial ao carrinho no banco de dados
const addCredencialToCartDatabase = async (credencialData) => {
  try {
    if (!user?.id) {
      throw new Error('Usuário não autenticado');
    }

    if (!credencialData.nome || !credencialData.cpf || !credencialData.empresa || !credencialData.tipo_credencial) {
      throw new Error('Dados da credencial incompletos');
    }

    // Buscar produto vinculado a credenciais
    const produtoReferencia = produtos.length > 0 ? produtos[0] : null;
    
    if (!produtoReferencia) {
      throw new Error('Nenhum produto disponível para credenciais');
    }

    // Dados da nova credencial
    const novaCredencialData = {
      id: credencialData.id,
      cpf: credencialData.cpf,
      empresa: credencialData.empresa,
      tipo_credencial: credencialData.tipo_credencial,
      tipoCredencialNome: tiposCredencial.find(t => t.id === credencialData.tipo_credencial)?.nome || 'Não especificado',
      observacoes: credencialData.observacoes,
      produto_id: produtoReferencia.id,
      produto_nome: produtoReferencia.nome,
      expositor_id: credencialData.expositor_id,
      evento_id: credencialData.evento_id
    };

    // Verificar se já existe item similar no carrinho
    const { data: existingItem } = await supabase
      .from('caex_carrinho_pedido')
      .select('*')
      .eq('usuario_id', user.id)
      .eq('produto_id', produtoReferencia.id)
      .contains('dados_extras', { category: 'Credencial' })
      .single();

    if (existingItem) {
      // Atualizar item existente adicionando a nova credencial
      let dadosExtrasAtualizados = { ...existingItem.dados_extras };
      
      // Verificar se credencialData já é um array ou objeto único
      if (Array.isArray(dadosExtrasAtualizados.credencialData)) {
        // Já é array, adicionar nova credencial
        dadosExtrasAtualizados.credencialData.push(novaCredencialData);
      } else {
        // É objeto único, converter para array e adicionar nova credencial
        dadosExtrasAtualizados.credencialData = [
          dadosExtrasAtualizados.credencialData,
          novaCredencialData
        ];
      }

      const { error } = await supabase
        .from('caex_carrinho_pedido')
        .update({
          quantidade: existingItem.quantidade + 1,
          dados_extras: dadosExtrasAtualizados,
          updated_at: new Date().toISOString()
        })
        .eq('id', existingItem.id);

      if (error) throw error;
      console.log('Credencial adicionada ao item existente no carrinho');
    } else {
      // Inserir novo item
      const cartData = {
        usuario_id: user.id,
        produto_id: produtoReferencia.id,
        quantidade: 1,
        preco_original: parseFloat(produtoReferencia.preco),
        preco_customizado: null,
        desconto: 0,
        tipo_desconto: 'value',
        dados_extras: {
          category: 'Credencial',
          credencialData: novaCredencialData
        }
      };

      const { error } = await supabase
        .from('caex_carrinho_pedido')
        .insert([cartData]);

      if (error) throw error;
      console.log('Nova credencial adicionada ao carrinho no banco');
    }

    // Atualizar contador do carrinho
    await loadCartFromDatabase();

    // Preparar dados para notificação
    const addedItem = {
      id: `credencial-${credencialData.id}`,
      name: credencialData.nome,
      description: `${tiposCredencial.find(t => t.id === credencialData.tipo_credencial)?.nome || 'Credencial'} - ${credencialData.empresa}`,
      price: produtoReferencia.preco,
      quantity: 1,
      category: 'Credencial'
    };

    setLastAddedItem(addedItem);
    setShowCartNotification(true);

    // Esconder notificação após 5 segundos
    setTimeout(() => {
      setShowCartNotification(false);
    }, 5000);

    return addedItem;
  } catch (error) {
    console.error('Erro ao adicionar credencial ao carrinho:', error);
    alert('Erro ao adicionar credencial ao carrinho: ' + error.message);
    return null;
  }
};
  // Buscar credenciais do banco de dados (MODIFICADO para administradores e expositores)
  const fetchCredenciais = async () => {
    try {
      setLoading(true);
      console.log('Iniciando carregamento de credenciais...');
      
      let query = supabase
        .from('caex_credenciais')
        .select('*')
        .order('id', { ascending: false });
      
      // Se não for admin e há expositor logado, filtrar por expositor
      if (!isAdmin() && expositorLogado) {
        query = query.eq('expositor_id', expositorLogado.id);
      }
      
      const { data, error } = await query;
      
      if (error) {
        console.error('Erro ao buscar credenciais:', error);
        throw error;
      }
      
      console.log('Credenciais carregadas:', data);
      
      // Aplicar máscara de CPF ao carregar dados
      const dataWithFormattedCpf = data ? data.map(credencial => ({
        ...credencial,
        cpf: credencial.cpf ? formatCpf(credencial.cpf) : ''
      })) : [];
      
      setCredenciais(dataWithFormattedCpf);
      setLoading(false);
    } catch (error) {
      console.error('Erro ao carregar credenciais:', error);
      setError('Não foi possível carregar a lista de credenciais.');
      setLoading(false);
    }
  };

  // Buscar expositores do banco de dados
  const fetchExpositores = async () => {
    try {
      console.log('Carregando expositores...');
      
      const { data, error } = await supabase
        .from('caex_expositores')
        .select('id, nome_empresa, cnpj')
        .eq('ativo', true)
        .order('nome_empresa');
      
      if (error) {
        console.error('Erro ao buscar expositores:', error);
        throw error;
      }
      
      console.log('Expositores carregados:', data);
      setExpositores(data || []);
    } catch (error) {
      console.error('Erro ao carregar expositores:', error);
    }
  };

  // Buscar produtos vinculados a credenciais de expositor
  const fetchProdutos = async () => {
    try {
      console.log('Carregando produtos vinculados a credenciais de expositor...');
      
      const { data, error } = await supabase
        .from('caex_produtos')
        .select('id, nome, descricao, preco, imagem_url')
        .eq('ativo', true)
        .eq('vinculado_credencial_expositor', true)
        .order('nome');
      
      if (error) {
        console.error('Erro ao buscar produtos:', error);
        throw error;
      }
      
      console.log('Produtos carregados:', data);
      setProdutos(data || []);
    } catch (error) {
      console.error('Erro ao carregar produtos:', error);
    }
  };

  // Carregar dados ao montar o componente
  useEffect(() => {
    const initializeData = async () => {
      if (user?.email) {
        await fetchExpositorLogado();
        await fetchExpositores();
        await fetchProdutos();
        await loadCartFromDatabase();
      }
    };
    
    initializeData();
  }, [user]);

  // Carregar credenciais quando expositor logado for definido ou se for admin
  useEffect(() => {
    if (expositorLogado || isAdmin()) {
      fetchCredenciais();
    }
  }, [expositorLogado, user]);

  // NOVO: Estado para expositor selecionado pelo admin
  const [expositorSelecionado, setExpositorSelecionado] = useState(null);

  // Chave para armazenar o estado do formulário no localStorage
  const FORM_STATE_KEY = 'credencial_expositor_form_state';

  // Salvar e restaurar estado do formulário quando a visibilidade da página muda
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden' && showForm) {
        // Salvar estado atual do formulário no localStorage
        try {
          const stateToSave = {
            formData,
            editingCredencial,
            activeModalTab,
            showForm
          };
          
          // Salvar apenas o ID do expositor selecionado para evitar objetos circulares
          if (expositorSelecionado) {
            stateToSave.expositorSelecionadoId = expositorSelecionado.id;
          }
          
          localStorage.setItem(FORM_STATE_KEY, JSON.stringify(stateToSave));
          console.log('💾 Estado do formulário de credencial expositor salvo no localStorage');
        } catch (error) {
          console.error('Erro ao salvar estado do formulário:', error);
        }
      } else if (document.visibilityState === 'visible') {
        // Verificar se há estado salvo e restaurar
        try {
          const savedState = localStorage.getItem(FORM_STATE_KEY);
          if (savedState) {
            const parsedState = JSON.parse(savedState);
            
            // Restaurar o estado do formulário
            setFormData(parsedState.formData || {});
            setEditingCredencial(parsedState.editingCredencial);
            setActiveModalTab(parsedState.activeModalTab || 'dados');
            setShowForm(parsedState.showForm);
            
            // Restaurar expositor selecionado a partir do ID
            if (parsedState.expositorSelecionadoId && expositores.length > 0) {
              const expositor = expositores.find(exp => exp.id === parsedState.expositorSelecionadoId);
              if (expositor) {
                setExpositorSelecionado(expositor);
              }
            }
            
            console.log('🔄 Estado do formulário de credencial expositor restaurado do localStorage');
          }
        } catch (error) {
          console.error('Erro ao restaurar estado do formulário:', error);
        }
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [formData, showForm, editingCredencial, activeModalTab, expositorSelecionado, expositores]);

  // Limpar estado salvo quando o formulário é fechado
  useEffect(() => {
    if (!showForm) {
      localStorage.removeItem(FORM_STATE_KEY);
    }
  }, [showForm]);

  // NOVA FUNÇÃO: Manipular seleção de expositor pelo admin
  const handleExpositorChange = async (e) => {
    const expositorId = e.target.value;
    
    if (expositorId) {
      const expositor = expositores.find(exp => exp.id === parseInt(expositorId));
      setExpositorSelecionado(expositor);
      
      // Atualizar empresa no formulário
      setFormData({
        ...formData,
        empresa: expositor ? expositor.nome_empresa : ''
      });
      
      // Buscar eventos vinculados ao expositor selecionado
      await fetchEventosVinculadosAoExpositor(parseInt(expositorId));
    } else {
      setExpositorSelecionado(null);
      setFormData({
        ...formData,
        empresa: ''
      });
      
      // Se for admin, mostrar todos os eventos
      if (isAdmin()) {
        await fetchTodosEventos();
      }
    }
  };

  // Componente para exibir eventos vinculados em dropdown
  const renderEventosDropdown = () => {
    if (eventosVinculados.length === 0) {
      return (
        <div style={{
          padding: '1rem',
          textAlign: 'center',
          color: '#6c757d',
          backgroundColor: '#f8f9fa',
          border: '1px solid #dee2e6',
          borderRadius: '8px'
        }}>
          <FaCalendarAlt style={{ marginBottom: '0.5rem', fontSize: '1.5rem' }} />
          <div>Nenhum evento vinculado a este expositor</div>
          <small>Entre em contato com o administrador para vincular eventos</small>
        </div>
      );
    }

    return (
      <select
        id="evento_id"
        name="evento_id"
        value={formData.evento_id}
        onChange={handleChange}
        className="form-input"
        required
      >
        <option value="">Selecione o evento</option>
        {eventosVinculados.map(evento => {
          const dataInicio = new Date(evento.data_inicio).toLocaleDateString('pt-BR');
          const dataFim = new Date(evento.data_fim).toLocaleDateString('pt-BR');
          const eventoLabel = `${evento.nome} (${dataInicio} - ${dataFim})`;
          
          return (
            <option key={evento.id} value={evento.id}>
              {eventoLabel}
            </option>
          );
        })}
      </select>
    );
  };

  // Renderizar campo de empresa
  const renderEmpresaField = () => {
    if (isAdmin()) {
      // Dropdown para admin selecionar expositor
      return (
        <div>
          <select
            id="expositor"
            name="expositor"
            value={expositorSelecionado?.id || ''}
            onChange={handleExpositorChange}
            className="form-input"
            required
          >
            <option value="">Selecione o expositor</option>
            {expositores.map(expositor => (
              <option key={expositor.id} value={expositor.id}>
                {expositor.nome_empresa} - {expositor.cnpj}
              </option>
            ))}
          </select>
          
          {expositorSelecionado && (
            <div className="empresa-bloqueada mt-2">
              <FaBuilding className="empresa-icon" />
              <div>
                <div style={{ fontWeight: '600' }}>{expositorSelecionado.nome_empresa}</div>
                <small>CNPJ: {expositorSelecionado.cnpj}</small>
              </div>
            </div>
          )}
        </div>
      );
    }

    if (expositorLogado) {
      return (
        <div className="empresa-bloqueada">
          <FaBuilding className="empresa-icon" />
          <div>
            <div style={{ fontWeight: '600' }}>{expositorLogado.nome_empresa}</div>
            <small>CNPJ: {expositorLogado.cnpj}</small>
          </div>
        </div>
      );
    }

    return (
      <input
        type="text"
        id="empresa"
        name="empresa"
        value={formData.empresa}
        onChange={handleChange}
        className="form-input"
        placeholder="Nome da empresa"
        disabled
      />
    );
  };

  const renderProdutosDropdown = () => {
    if (produtos.length === 0) {
      return (
        <div style={{
          padding: '1rem',
          textAlign: 'center',
          color: '#6c757d',
          backgroundColor: '#f8f9fa',
          border: '1px solid #dee2e6',
          borderRadius: '8px'
        }}>
          <FaBox style={{ marginBottom: '0.5rem', fontSize: '1.5rem' }} />
          <div>Nenhum produto disponível para credenciais de expositor</div>
        </div>
      );
    }

    return (
      <div>
        <div style={{ marginBottom: '1rem', fontSize: '0.9rem', color: '#6c757d' }}>
          Produtos vinculados à credencial:
        </div>
        
        {produtos.map(produto => (
          <div
            key={produto.id}
            className="produto-card selected"
          >
            <div style={{ marginRight: '0.75rem', display: 'flex', alignItems: 'center' }}>
              <input
                type="checkbox"
                checked={true}
                disabled={true}
                style={{
                  width: '18px',
                  height: '18px',
                  accentColor: '#28a745',
                  cursor: 'not-allowed'
                }}
                readOnly
              />
            </div>
            
            <div className="produto-image">
              {produto.imagem_url ? (
                <img 
                  src={produto.imagem_url} 
                  alt={produto.nome}
                  style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '6px' }}
                />
              ) : (
                <FaBox style={{ color: '#6c757d', fontSize: '1.2rem' }} />
              )}
            </div>
            
            <div className="produto-info">
              <div className="produto-nome">{produto.nome}</div>
            </div>
          </div>
        ))}
        
        <div style={{
          marginTop: '1rem',
          padding: '0.75rem',
          backgroundColor: '#d1ecf1',
          color: '#0c5460',
          border: '1px solid #bee5eb',
          borderRadius: '8px',
          fontSize: '0.85rem',
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem'
        }}>
          <FaCheckCircle />
          Todos os produtos estão automaticamente vinculados às credenciais de expositor
        </div>
      </div>
    );
  };

  // Handlers
  const handleAddCredencial = () => {
    setEditingCredencial(null);
    setExpositorSelecionado(null);
    setCpfError('');
    setCpfValid(null);
    
    setFormData({
      nome: '',
      cpf: '',
      empresa: '',
      tipo_credencial: '',
      observacoes: '',
      evento_id: ''
    });
    setShowForm(true);
    setActiveModalTab('dados');
    
    // Se for admin, carregar todos os eventos
    if (isAdmin()) {
      fetchTodosEventos();
    }
  };

  const handleEditCredencial = (credencial) => {
    setEditingCredencial(credencial);
    setCpfError('');
    setCpfValid(null);

    // Se for admin e a credencial tem expositor_id, selecionar o expositor
    if (isAdmin() && credencial.expositor_id) {
      const expositor = expositores.find(exp => exp.id === credencial.expositor_id);
      setExpositorSelecionado(expositor || null);
      
      // Carregar eventos do expositor
      if (expositor) {
        fetchEventosVinculadosAoExpositor(expositor.id);
      }
    }

    const cpfFormatado = credencial.cpf ? formatCpf(credencial.cpf) : '';
    
    setFormData({
      nome: credencial.nome,
      cpf: cpfFormatado,
      empresa: credencial.empresa,
      tipo_credencial: credencial.tipo_credencial,
      observacoes: credencial.observacoes,
      evento_id: credencial.evento_id?.toString() || ''
    });

    // Validar CPF se estiver presente
    if (cpfFormatado) {
      const isValid = validateCpf(cpfFormatado);
      setCpfValid(isValid);
    }

    setShowForm(true);
    setActiveModalTab('dados');
  };

  const handleDeleteCredencial = (credencial) => {
    setEditingCredencial(credencial);
    setShowDelete(true);
  };

  // Excluir credencial do banco de dados
  const deleteCredencial = async (id) => {
    try {
      const { error } = await supabase
        .from('caex_credenciais')
        .delete()
        .eq('id', id);
      
      if (error) throw error;
      
      setCredenciais(credenciais.filter(credencial => credencial.id !== id));
      setShowDelete(false);
    } catch (error) {
      console.error('Erro ao excluir credencial:', error);
      alert('Não foi possível excluir a credencial. Por favor, tente novamente.');
    }
  };

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    
    if (!formData.nome || !formData.cpf || !formData.tipo_credencial) {
      alert('Por favor, preencha todos os campos obrigatórios.');
      return;
    }

    // Validar CPF antes de submeter
    if (!validateCpf(formData.cpf)) {
      alert('Por favor, digite um CPF válido.');
      setCpfError('CPF inválido. Verifique os números digitados.');
      return;
    }

    if (!formData.evento_id) {
      alert('Por favor, selecione um evento para vincular esta credencial.');
      return;
    }

    // Validação para admin: deve selecionar expositor
    if (isAdmin() && !expositorSelecionado) {
      alert('Por favor, selecione um expositor para vincular esta credencial.');
      return;
    }

    // Validação para expositor: deve estar logado
    if (!isAdmin() && !expositorLogado) {
      alert('Erro: Expositor não identificado. Faça login novamente.');
      return;
    }
    
    try {
      // Determinar qual expositor usar
      const expositorParaUsar = isAdmin() ? expositorSelecionado : expositorLogado;
      
      const credencialData = {
        nome: formData.nome,
        cpf: removeCpfMask(formData.cpf), // Remove máscara do CPF antes de salvar
        empresa: expositorParaUsar.nome_empresa,
        tipo_credencial: formData.tipo_credencial,
        observacoes: formData.observacoes,
        expositor_id: expositorParaUsar.id,
        evento_id: parseInt(formData.evento_id),
        updated_at: new Date()
      };

      if (editingCredencial) {
        const { error } = await supabase
          .from('caex_credenciais')
          .update(credencialData)
          .eq('id', editingCredencial.id);
        
        if (error) throw error;
        
        console.log('Credencial atualizada com sucesso');
        
        // Atualizar lista local com CPF formatado
        setCredenciais(credenciais.map(credencial => 
          credencial.id === editingCredencial.id ? { 
            ...credencial, 
            ...credencialData,
            cpf: formatCpf(credencialData.cpf) // Aplicar máscara ao exibir
          } : credencial
        ));
      } else {
        const { data, error } = await supabase
          .from('caex_credenciais')
          .insert([credencialData])
          .select();
        
        if (error) throw error;
        
        console.log('Credencial adicionada com sucesso:', data);
        
        // Adicionar à lista local com CPF formatado
        const newCredencial = {
          ...data[0],
          cpf: formatCpf(data[0].cpf) // Aplicar máscara ao exibir
        };
        
        setCredenciais([newCredencial, ...credenciais]);
        
        // Adicionar ao carrinho no banco de dados
        await addCredencialToCartDatabase(data[0]);
      }
      
      setShowForm(false);
      
      if (!editingCredencial) {
        setExpositorSelecionado(null);
        setCpfError('');
        setCpfValid(null);
        setFormData({
          nome: '',
          cpf: '',
          empresa: '',
          tipo_credencial: '',
          observacoes: '',
          evento_id: ''
        });
      }
    } catch (error) {
      console.error('Erro ao salvar credencial:', error);
      alert(`Não foi possível salvar a credencial. Erro: ${error.message || 'Desconhecido'}`);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({
      ...filters,
      [name]: value
    });
  };

  const handleEmpresaChange = (e) => {
    setFiltroEmpresa(e.target.value);
  };

  const handleTabClick = (tab) => {
    if (tab === 'acesso') {
      return;
    }
    setActiveModalTab(tab);
  };

  const navigateToCart = () => {
    navigate('/catalog/new-order');
  };

  // Renderizar notificação de carrinho
  const renderCartNotification = () => {
    if (!showCartNotification) return null;
    
    return (
      <div className="cart-notification-alert">
        <div className="alert">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <FaCheckCircle className="me-2" />
              <strong>Credencial adicionada ao carrinho!</strong>
            </div>
            <Button 
              variant="outline-dark" 
              size="sm"
              onClick={() => setShowCartNotification(false)}
              className="ms-3"
            >
              <FaTimes />
            </Button>
          </div>
          
          {lastAddedItem && (
            <div className="cart-item-preview mt-2 p-2 rounded">
              <div className="d-flex align-items-center">
                <div className="me-3">
                  <FaIdBadge size={24} className="text-secondary" />
                </div>
                <div>
                  <h6 className="mb-0">{lastAddedItem.name}</h6>
                  <small>{lastAddedItem.description}</small>
                </div>
              </div>
            </div>
          )}
          
          <div className="d-flex justify-content-end mt-3">
            <Button 
              variant="outline-dark" 
              size="sm" 
              className="me-2"
              onClick={() => handleAddCredencial()}
            >
              <FaPlus className="me-1" /> Adicionar Outra
            </Button>
            <Button 
              variant="dark" 
              size="sm"
              onClick={navigateToCart}
            >
              Ir para o Carrinho <FaArrowRight className="ms-1" />
            </Button>
          </div>
        </div>
      </div>
    );
  };

  // Renderizar botão de carrinho
  const renderCartButton = () => {
    if (cartItemsCount === 0) return null;
    
    return (
      <Button 
        variant="outline-dark" 
        className="cart-button ms-2"
        onClick={navigateToCart}
      >
        <FaShoppingCart className="me-1" />
        Carrinho
        <span className="cart-count">{cartItemsCount}</span>
      </Button>
    );
  };

  // Funções de renderização
  const renderStatusBadge = (status) => {
    switch (status) {
      case 'ativo':
        return <Badge bg="success" className="modern-badge">Ativo</Badge>;
      case 'inativo':
        return <Badge bg="danger" className="modern-badge">Inativo</Badge>;
      case 'suspenso':
        return <Badge bg="warning" className="modern-badge">Suspenso</Badge>;
      default:
        return <Badge bg="secondary" className="modern-badge">Indefinido</Badge>;
    }
  };

  const renderTipoCredencialBadge = (tipo) => {
    const colors = {
      'representante': 'primary',
      'funcionario': 'info',
      'visitante': 'secondary',
      'fornecedor': 'warning',
      'convidado': 'success'
    };
    
    const tipoObj = tiposCredencial.find(t => t.id === tipo);
    return (
      <Badge bg={colors[tipo] || 'secondary'} className="modern-badge">
        {tipoObj ? tipoObj.nome : tipo}
      </Badge>
    );
  };

  // Filtragem de credenciais
  const filteredCredenciais = credenciais.filter(credencial => {
    if (filtroEmpresa && credencial.empresa !== filtroEmpresa) {
      return false;
    }
    
    if (filters.search) {
      const searchTerm = filters.search.toLowerCase();
      return credencial.nome.toLowerCase().includes(searchTerm) || 
             credencial.cpf.includes(searchTerm);
    }
    
    if (filters.tipo_credencial && credencial.tipo_credencial !== filters.tipo_credencial) {
      return false;
    }
    
    return true;
  });

  // Estilos para o modal flutuante
  const modalStyles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      padding: '1rem',
      backdropFilter: 'blur(5px)'
    },
    content: {
      position: 'relative',
      width: '100%',
      maxWidth: '650px',
      maxHeight: '90vh',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: 'white',
      borderRadius: '20px',
      boxShadow: '0 20px 60px rgba(0, 0, 0, 0.15)',
      border: '1px solid rgba(255, 255, 255, 0.2)',
      overflow: 'hidden',
      animationName: 'fadeInUp',
      animationDuration: '0.4s',
      animationTimingFunction: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)',
      animationFillMode: 'both'
    },
    header: {
      background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
      borderBottom: '1px solid rgba(0, 0, 0, 0.05)',
      padding: '1.5rem 2rem',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexShrink: 0
    },
    closeButton: {
      width: '36px',
      height: '36px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '50%',
      border: 'none',
      background: 'white',
      color: '#6c757d',
      fontSize: '1rem',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)'
    },
    title: {
      fontSize: '1.25rem',
      fontWeight: '600',
      color: '#1a1a1a',
      margin: '0',
      display: 'flex',
      alignItems: 'center',
      gap: '0.75rem'
    },
    tabs: {
      display: 'flex',
      borderBottom: '1px solid rgba(0, 0, 0, 0.05)',
      backgroundColor: 'white',
      flexShrink: 0
    },
    tab: {
      padding: '1rem 1.5rem',
      fontSize: '0.95rem',
      fontWeight: '500',
      color: '#6c757d',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      position: 'relative'
    },
    activeTab: {
      color: '#0d6efd',
      fontWeight: '600'
    },
    disabledTab: {
      color: '#adb5bd',
      cursor: 'not-allowed',
      opacity: 0.6
    },
    activeTabIndicator: {
      position: 'absolute',
      bottom: '-1px',
      left: '0',
      right: '0',
      height: '2px',
      backgroundColor: '#0d6efd'
    },
    body: {
      padding: '2rem',
      overflowY: 'auto',
      flex: '1 1 auto'
    },
    footer: {
      display: 'flex',
      justifyContent: 'flex-end',
      padding: '1.5rem 2rem',
      borderTop: '1px solid rgba(0, 0, 0, 0.05)',
      background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
      flexShrink: 0
    },
    footerButton: {
      padding: '0.75rem 1.5rem',
      borderRadius: '50px',
      fontSize: '0.9rem',
      fontWeight: '600',
      transition: 'all 0.3s ease',
      cursor: 'pointer'
    },
    cancelButton: {
      border: '1px solid #dee2e6',
      background: 'white',
      color: '#495057',
      marginRight: '0.75rem'
    },
    submitButton: {
      border: 'none',
      background: '#212529',
      color: 'white',
      boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)'
    },
    formGroup: {
      marginBottom: '1.5rem'
    },
    formLabel: {
      display: 'block',
      marginBottom: '0.5rem',
      fontSize: '0.9rem',
      fontWeight: '600',
      color: '#495057'
    },
    formInput: {
      width: '100%',
      padding: '0.75rem 1rem',
      border: '1px solid #dee2e6',
      borderRadius: '10px',
      fontSize: '0.9rem',
      color: '#495057',
      transition: 'all 0.3s ease'
    },
    requiredField: {
      color: '#dc3545',
      marginLeft: '0.25rem'
    },
    requiredNotice: {
      fontSize: '0.8rem',
      color: '#dc3545',
      marginBottom: '1rem'
    }
  };

  // Adicionar estilo de animação ao carregar o componente
  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      @keyframes fadeInUp {
        from { 
          opacity: 0; 
          transform: translateY(30px);
        }
        to { 
          opacity: 1; 
          transform: translateY(0);
        }
      }
      
      .form-input {
        width: 100%;
        padding: 0.75rem 1rem;
        border: 1px solid #dee2e6;
        border-radius: 10px;
        font-size: 0.9rem;
        color: #495057;
        transition: all 0.3s ease;
      }
      
      .form-input:focus {
        outline: none;
        border-color: #212529;
        box-shadow: 0 0 0 3px rgba(33, 37, 41, 0.1);
      }
      
      .form-input:disabled {
        background-color: #f8f9fa;
        color: #6c757d;
        cursor: not-allowed;
      }
      
      .form-input.cpf-valid {
        border-color: #28a745;
        box-shadow: 0 0 0 3px rgba(40, 167, 69, 0.1);
      }
      
      .form-input.cpf-invalid {
        border-color: #dc3545;
        box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1);
      }
      
      .cpf-validation-message {
        font-size: 0.8rem;
        margin-top: 0.25rem;
        display: flex;
        align-items: center;
        gap: 0.25rem;
      }
      
      .cpf-validation-message.valid {
        color: #28a745;
      }
      
      .cpf-validation-message.invalid {
        color: #dc3545;
      }
      
      .form-label {
        display: block;
        margin-bottom: 0.5rem;
        font-size: 0.9rem;
        font-weight: 600;
        color: #495057;
      }
      
      .form-group {
        margin-bottom: 1.5rem;
      }
      
      .modal-close-btn:hover {
        background-color: #f8f9fa;
        color: #212529;
        transform: rotate(90deg);
      }
      
      .btn-cancel:hover {
        background-color: #f8f9fa;
      }
      
      .btn-submit:hover {
        background-color: #343a40;
        transform: translateY(-2px);
        box-shadow: 0 6px 15px rgba(0, 0, 0, 0.15);
      }
      
      .modal-tab {
        position: relative;
        padding: 1rem 1.5rem;
        font-weight: 500;
        color: #6c757d;
        cursor: pointer;
        transition: all 0.3s ease;
      }
      
      .modal-tab-active {
        color: #0d6efd;
        font-weight: 600;
      }
      
      .modal-tab-disabled {
        color: #adb5bd;
        cursor: not-allowed;
        opacity: 0.6;
      }
      
      .modal-tab-active::after {
        content: '';
        position: absolute;
        bottom: -1px;
        left: 0;
        right: 0;
        height: 2px;
        background-color: #0d6efd;
      }
      
      .modal-tab:hover:not(.modal-tab-active):not(.modal-tab-disabled) {
        color: #495057;
        background-color: rgba(0, 0, 0, 0.02);
      }

      .cart-notification-alert {
        position: fixed;
        bottom: 20px;
        right: 20px;
        z-index: 1050;
        width: 350px;
        animation: slideInRight 0.3s ease-out forwards;
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
        border-radius: 10px;
        overflow: hidden;
      }
      
      .cart-notification-alert .alert {
        margin-bottom: 0;
        padding: 15px 20px;
        border: none;
        border-radius: 10px;
        background: #212529;
        color: white;
      }
      
      .cart-notification-alert .btn-outline-dark {
        color: white;
        border-color: rgba(255, 255, 255, 0.5);
        transition: all 0.2s ease;
      }
      
      .cart-notification-alert .btn-outline-dark:hover {
        background-color: rgba(255, 255, 255, 0.2);
        border-color: white;
      }
      
      .cart-notification-alert .btn-dark {
        background-color: white;
        color: #212529;
        border: none;
        transition: all 0.2s ease;
      }
      
      .cart-notification-alert .btn-dark:hover {
        background-color: #f8f9fa;
        transform: translateY(-2px);
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
      }
      
      .cart-button {
        position: relative;
        transition: all 0.3s ease;
      }
      
      .cart-button:hover {
        transform: translateY(-2px);
      }
      
      .cart-button .cart-count {
        position: absolute;
        top: -8px;
        right: -8px;
        background-color: #dc3545;
        color: white;
        border-radius: 50%;
        width: 20px;
        height: 20px;
        font-size: 0.7rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
      }
      
      @keyframes slideInRight {
        from {
          transform: translateX(100%);
          opacity: 0;
        }
        to {
          transform: translateX(0);
          opacity: 1;
        }
      }
      
      .cart-item-added {
        animation: cartBounce 0.5s ease;
      }
      
      @keyframes cartBounce {
        0% { transform: scale(1); }
        50% { transform: scale(1.2); }
        100% { transform: scale(1); }
      }
      
      .cart-item-preview {
        border: 1px solid rgba(255, 255, 255, 0.3);
        background-color: #f8f9fa;
        color: #212529;
      }

      .empresa-bloqueada {
        background-color: #f8f9fa;
        border: 1px solid #dee2e6;
        border-radius: 10px;
        padding: 0.75rem 1rem;
        color: #6c757d;
        display: flex;
        align-items: center;
        gap: 0.5rem;
        font-weight: 500;
      }
      
      .empresa-bloqueada .empresa-icon {
        color: #28a745;
      }

      .produto-card {
        display: flex;
        align-items: center;
        padding: 0.75rem;
        border: 1px solid #28a745;
        border-radius: 8px;
        margin-bottom: 0.5rem;
        background: #f8fff9;
        cursor: not-allowed;
        transition: all 0.2s ease;
      }
      
      .produto-card.selected {
        border-color: #28a745;
        background-color: #f8fff9;
        box-shadow: 0 2px 8px rgba(40, 167, 69, 0.15);
      }
      
      .produto-image {
        width: 40px;
        height: 40px;
        border-radius: 6px;
        background-color: #f8f9fa;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 0.75rem;
        flex-shrink: 0;
      }
      
      .produto-info {
        flex: 1;
      }
      
      .produto-nome {
        font-weight: 600;
        color: #212529;
        font-size: 0.9rem;
      }
    `;
    document.head.appendChild(style);
    
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  // Impedir o scroll quando o modal estiver aberto
  useEffect(() => {
    if (showForm || showDelete) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [showForm, showDelete]);
  
  // Adicionar efeito para rolar o modal para o topo quando for aberto
  useEffect(() => {
    if (showForm) {
      setTimeout(() => {
        const modalBody = document.querySelector('.modal-scrollable-body');
        if (modalBody) {
          modalBody.scrollTop = 0;
        }
      }, 100);
    }
  }, [showForm, activeModalTab]);

  if (loading) {
    return (
      <div className="dashboard-container">
        <div className="dashboard-hub">
          <div className="dashboard-header">
            <div className="dashboard-title-section">
              <h1 className="dashboard-main-title">
                <FaIdBadge className="dashboard-title-icon" />
                Credenciais Expositor
              </h1>
            </div>
          </div>
          <div className="flex justify-center items-center h-64">
            <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-gray-900"></div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="dashboard-container">
        <div className="dashboard-hub">
          <div className="dashboard-header">
            <div className="dashboard-title-section">
              <h1 className="dashboard-main-title">
                <FaIdBadge className="dashboard-title-icon" />
                Credenciais Expositor
              </h1>
            </div>
          </div>
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative my-4" role="alert">
            <strong className="font-bold">Erro: </strong>
            <span className="block sm:inline">{error}</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      <div className="dashboard-hub">
        <div className="dashboard-header">
          <div className="dashboard-title-section">
            <h1 className="dashboard-main-title">
              <FaIdBadge className="dashboard-title-icon" />
              Credenciais Expositor
            </h1>
            <p className="dashboard-subtitle">
              Gerenciamento de credenciais de acesso para expositores e colaboradores
              {!isAdmin() && expositorLogado && (
                <span style={{ display: 'block', marginTop: '0.5rem', fontSize: '0.9rem', color: '#28a745' }}>
                  <FaBuilding className="me-1" />
                  {expositorLogado.nome_empresa}
                </span>
              )}
              {isAdmin() && (
                <span style={{ display: 'block', marginTop: '0.5rem', fontSize: '0.9rem', color: '#007bff' }}>
                  <FaUserTie className="me-1" />
                  Modo Administrador - Acesso Total
                </span>
              )}
            </p>
          </div>
        </div>

        <div className="d-flex justify-content-end mb-4">
          <Button 
            variant="outline-secondary" 
            className="me-2"
            onClick={() => setShowFilters(!showFilters)}
          >
            {showFilters ? <FaTimes className="me-2" /> : <FaFilter className="me-2" />}
            {showFilters ? 'Ocultar Filtros' : 'Filtros'}
          </Button>
          
          {renderCartButton()}
          
          <Button 
            variant="primary" 
            onClick={handleAddCredencial}
            className="bg-black text-white px-4 py-2 rounded-md hover:bg-gray-800 transition-all flex items-center gap-2 ms-2"
            style={{ boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}
            disabled={!isAdmin() && !expositorLogado}
          >
            <FaPlus className="me-2" />
            Nova Credencial
          </Button>
        </div>

        {/* Área de filtros */}
        {showFilters && (
          <Card className="modern-table-card mb-4">
            <Card.Body className="modern-card-body">
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Buscar por Nome ou CPF</Form.Label>
                    <div className="position-relative">
                      <Form.Control 
                        type="text" 
                        placeholder="Digite para buscar..."
                        name="search"
                        value={filters.search}
                        onChange={handleFilterChange}
                      />
                      <FaSearch className="position-absolute top-50 end-0 translate-middle-y me-3 text-muted" />
                    </div>
                  </Form.Group>
                </Col>
                
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Tipo de Credencial</Form.Label>
                    <Form.Select 
                      name="tipo_credencial"
                      value={filters.tipo_credencial}
                      onChange={handleFilterChange}
                    >
                      <option value="">Todos os tipos</option>
                      {tiposCredencial.map(tipo => (
                        <option key={tipo.id} value={tipo.id}>
                          {tipo.nome}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                
              </Row>
            </Card.Body>
          </Card>
        )}

        <div className="dashboard-section-header">
          <h2 className="dashboard-section-title">
            <FaUsers className="dashboard-section-icon" />
            Lista de Credenciais
          </h2>
          <p className="dashboard-section-subtitle">
            Visualize e gerencie as credenciais de acesso cadastradas
            {!isAdmin() && expositorLogado && ` para ${expositorLogado.nome_empresa}`}
            {isAdmin() && ' - Todas as empresas'}
          </p>
        </div>

        {/* Tabela de credenciais */}
        <Card className="modern-table-card">
          <Card.Body className="modern-card-body">
            <div className="modern-table-container">
              <table className="modern-table">
                <thead>
                  <tr>
                    <th>Nome</th>
                    <th>CPF</th>
                    <th>Empresa</th>
                    <th>Tipo de Credencial</th>
                    <th>Status</th>
                    <th>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredCredenciais.length > 0 ? (
                    filteredCredenciais.map(credencial => (
                      <tr key={credencial.id}>
                        <td className="font-weight-bold">{credencial.nome}</td>
                        <td>{credencial.cpf}</td>
                        <td>{credencial.empresa}</td>
                        <td>{renderTipoCredencialBadge(credencial.tipo_credencial)}</td>
                        <td>{renderStatusBadge(credencial.status)}</td>
                        <td>
                          <div className="action-buttons">
                            <Button 
                              variant="outline-primary" 
                              size="sm"
                              onClick={() => handleEditCredencial(credencial)}
                              className="me-1"
                              title="Editar"
                            >
                              <FaEdit />
                            </Button>
                            {/* <Button 
                              variant="outline-danger" 
                              size="sm"
                              onClick={() => handleDeleteCredencial(credencial)}
                              title="Excluir"
                            > */}
                              {/* <FaTrash /> */}
                            {/* </Button> */}
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center py-4">
                        <p className="text-muted mb-0">
                          {!isAdmin() && expositorLogado 
                            ? 'Nenhuma credencial encontrada para esta empresa' 
                            : isAdmin()
                            ? 'Nenhuma credencial encontrada no sistema'
                            : 'Nenhuma credencial encontrada'
                          }
                        </p>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </Card.Body>
        </Card>

        {/* Modal de formulário */}
        {showForm && (
          <div style={modalStyles.overlay}>
            <div style={modalStyles.content}>
              <div style={modalStyles.header}>
                <h2 style={modalStyles.title}>
                  {editingCredencial 
                    ? <FaEdit style={{color: '#6c757d'}} /> 
                    : <FaPlus style={{color: '#6c757d'}} />
                  }
                  {editingCredencial ? 'Editar Credencial' : 'Nova Credencial'}
                </h2>
                <button 
                  onClick={() => setShowForm(false)}
                  style={modalStyles.closeButton}
                  className="modal-close-btn"
                  aria-label="Fechar"
                >
                  ✕
                </button>
              </div>

              <div style={modalStyles.tabs}>
                <div 
                  className={`modal-tab ${activeModalTab === 'dados' ? 'modal-tab-active' : ''}`}
                  onClick={() => handleTabClick('dados')}
                >
                  Dados Pessoais
                </div>
                <div 
                  className={`modal-tab ${activeModalTab === 'credencial' ? 'modal-tab-active' : ''}`}
                  onClick={() => handleTabClick('credencial')}
                >
                  Credencial & Evento
                </div>
              </div>
              
              <div style={modalStyles.body} className="modal-scrollable-body">
                {activeModalTab === 'dados' && (
                  <>
                    <div className="form-group">
                      <label className="form-label" htmlFor="empresa">
                        {isAdmin() ? 'Selecionar Expositor' : 'Empresa Expositora'}
                        {isAdmin() && <span style={modalStyles.requiredField}>*</span>}
                      </label>
                      {renderEmpresaField()}
                      <small style={{ color: '#6c757d', fontSize: '0.8rem', marginTop: '0.25rem', display: 'block' }}>
                        {isAdmin() 
                          ? 'Selecione o expositor responsável por esta credencial' 
                          : expositorLogado 
                          ? 'Empresa vinculada ao seu login' 
                          : 'Empresa não identificada'
                        }
                      </small>
                    </div>

                    <div className="form-group">
                      <label className="form-label" htmlFor="evento_id">
                        Evento <span style={modalStyles.requiredField}>*</span>
                      </label>
                      {renderEventosDropdown()}
                    </div>
                    
                    <div className="form-group">
                      <label className="form-label" htmlFor="nome">
                        Nome Completo <span style={modalStyles.requiredField}>*</span>
                      </label>
                      <input
                        type="text"
                        id="nome"
                        name="nome"
                        value={formData.nome}
                        onChange={handleChange}
                        className="form-input"
                        placeholder="Digite o nome completo"
                        required
                      />
                    </div>
                    
                    <div className="form-group">
                      <label className="form-label" htmlFor="cpf">
                        CPF <span style={modalStyles.requiredField}>*</span>
                      </label>
                      <input
                        type="text"
                        id="cpf"
                        name="cpf"
                        value={formData.cpf}
                        onChange={handleCpfChange}
                        className={`form-input ${
                          cpfValid === true ? 'cpf-valid' : 
                          cpfValid === false ? 'cpf-invalid' : ''
                        }`}
                        placeholder="000.000.000-00"
                        maxLength="14"
                        required
                      />
                      {cpfError && (
                        <div className="cpf-validation-message invalid">
                          <FaExclamationTriangle />
                          {cpfError}
                        </div>
                      )}
                      {cpfValid === true && (
                        <div className="cpf-validation-message valid">
                          <FaCheckCircle />
                          CPF válido
                        </div>
                      )}
                    </div>
                    
                    <div style={modalStyles.requiredNotice}>
                      * Campos obrigatórios
                    </div>
                  </>
                )}
                
                {activeModalTab === 'credencial' && (
                  <>
                    <div className="form-group">
                      <label className="form-label" htmlFor="tipo_credencial">
                        Tipo de Credencial <span style={modalStyles.requiredField}>*</span>
                      </label>
                      <select
                        id="tipo_credencial"
                        name="tipo_credencial"
                        value={formData.tipo_credencial}
                        onChange={handleChange}
                        className="form-input"
                        required
                      >
                        <option value="">Selecione o tipo de credencial</option>
                        {tiposCredencial.map(tipo => (
                          <option key={tipo.id} value={tipo.id}>
                            {tipo.nome}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="form-group">
                      <label className="form-label" htmlFor="produto">
                        <FaBox className="me-2" />
                        Produtos Vinculados à Credencial
                      </label>
                      {renderProdutosDropdown()}
                      <small style={{ color: '#6c757d', fontSize: '0.8rem', marginTop: '0.25rem', display: 'block' }}>
                        Produtos automaticamente vinculados a credenciais de expositor (apenas para visualização)
                      </small>
                    </div>
                    
                    <div className="form-group">
                      <label className="form-label" htmlFor="observacoes">
                        Observações e Restrições
                      </label>
                      <textarea
                        id="observacoes"
                        name="observacoes"
                        value={formData.observacoes}
                        onChange={handleChange}
                        className="form-input"
                        placeholder="Digite observações sobre o acesso, restrições especiais, etc."
                        rows={4}
                      />
                    </div>
                    
                    <div style={{
                      backgroundColor: '#cff4fc',
                      color: '#055160',
                      padding: '1rem',
                      borderRadius: '10px',
                      border: '1px solid #b6effb',
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: '0.5rem',
                      marginBottom: '1rem'
                    }}>
                      <FaExclamationTriangle style={{marginTop: '0.2rem'}} />
                      <div>
                        <strong>Tipos de Credencial:</strong><br />
                        <small>
                          • <strong>Representante:</strong> Acesso total às áreas da empresa<br />
                          • <strong>Funcionário:</strong> Acesso limitado às áreas de trabalho<br />
                          • <strong>Visitante:</strong> Acesso supervisionado<br />
                          • <strong>Fornecedor/Parceiro:</strong> Acesso para serviços específicos<br />
                          • <strong>Convidado Especial:</strong> Acesso VIP
                        </small>
                      </div>
                    </div>
                    
                    <div style={modalStyles.requiredNotice}>
                      * Campos obrigatórios
                    </div>
                  </>
                )}
              </div>
              
              <div style={modalStyles.footer}>
                <button
                  type="button"
                  onClick={() => setShowForm(false)}
                  style={{...modalStyles.footerButton, ...modalStyles.cancelButton}}
                  className="btn-cancel"
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  onClick={handleSubmit}
                  style={{...modalStyles.footerButton, ...modalStyles.submitButton}}
                  className="btn-submit"
                >
                  {editingCredencial ? 'Atualizar' : 'Salvar'}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Modal de confirmação de exclusão */}
        {showDelete && (
          <div style={modalStyles.overlay}>
            <div style={{...modalStyles.content, maxWidth: '500px'}}>
              <div style={modalStyles.header}>
                <h2 style={modalStyles.title}>
                  <FaTrash style={{color: '#dc3545'}} />
                  Confirmar Exclusão
                </h2>
                <button 
                  onClick={() => setShowDelete(false)}
                  style={modalStyles.closeButton}
                  className="modal-close-btn"
                  aria-label="Fechar"
                >
                  ✕
                </button>
              </div>
              
              <div style={modalStyles.body} className="modal-scrollable-body">
                {editingCredencial && (
                  <p style={{fontSize: '1rem', marginBottom: '1.5rem'}}>
                    Tem certeza que deseja excluir a credencial de <strong>{editingCredencial.nome}</strong>?
                  </p>
                )}
                
                <div style={{
                  backgroundColor: '#fff3cd',
                  color: '#856404',
                  padding: '1rem',
                  borderRadius: '10px',
                  border: '1px solid #ffeeba',
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '0.5rem'
                }}>
                  <FaExclamationTriangle style={{marginTop: '0.2rem'}} />
                  <div>
                    Esta ação não pode ser desfeita e o acesso da credencial será revogado imediatamente.
                  </div>
                </div>
              </div>
              
              <div style={modalStyles.footer}>
                <button
                  type="button"
                  onClick={() => setShowDelete(false)}
                  style={{...modalStyles.footerButton, ...modalStyles.cancelButton}}
                  className="btn-cancel"
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  onClick={() => deleteCredencial(editingCredencial.id)}
                  style={{
                    ...modalStyles.footerButton,
                    ...modalStyles.submitButton,
                    background: '#dc3545'
                  }}
                  className="btn-submit"
                >
                  Excluir
                </button>
              </div>
            </div>
          </div>
        )}
        
        {/* Notificação de adição ao carrinho */}
        {renderCartNotification()}
      </div>
    </div>
  );
};

export default CadastroCredenciais;